<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-膳食改进需求
-->

<template>
  <div class="bodyinfo-page">
    <div class="title">膳食改进需求</div>
    <div class="form-wrapper">
      <van-form @submit="onSubmit" scroll-to-error="true">
        <div class="form-item" v-for="item in qsList" :key="item.name">
          <div class="form-item-label">{{ item.label }}</div>
          <div class="form-item-input">
            <van-field :name="item.name" :rules="[{ required: true, message: '请选择' }]">
              <template #input>
                <van-radio-group v-model="formData[item.name]" direction="vertical" icon-size="1.33rem">
                  <van-radio class="van-radio__label" v-for="opt in item.options" :key="opt.key" :name="opt.key"
                    checked-color="#FBB13D">{{ opt.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </div>


        <div class="next-btn-wrapper">
          <van-button round block color="#FBB13D" native-type="button" plain @click="onClickPrev">上一页</van-button>
          <van-button round block color="#FBB13D" type="info" native-type="submit">下一页</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DietaryImprovement',
  props: {
    initData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      qsList: [{
      //   label: '1.最需改善的方面？',
      //   name: 'dietGjZxgsdfm',
      //   options: [{
      //     label: "体重管理",
      //     key: '1'
      //   }, {
      //     label: "慢性病饮食",
      //     key: '2'
      //   }, {
      //     label: "儿童/老人营养",
      //     key: '3'
      //   },{
      //     label: "运动营养",
      //     key: '4'
      //   }]
      // }, {
        label: '1.偏好的指导形式？',
        name: 'dietGjPhdzdxs',
        options: [{
          label: "个性化食谱",
          key: '1'
        }, {
          label: "营养知识讲座",
          key: '2'
        }, {
          label: "线上咨询",
          key: '3'
        },{
          label: "社群监督",
          key: '4'
        }]
      }, {
        label: '2.改变饮食的主要困难？',
        name: 'dietGjGbysdzykn',
        options: [{
          label: "时间不足",
          key: '1'
        }, {
          label: "经济成本",
          key: '2'
        }, {
          label: "缺乏知识",
          key: '3'
        },{
          label: "家庭成员阻力",
          key: '4'
        }]
      }, {
        label: '3.可接受的膳食调整强度？',
        name: 'dietGjKjsdsstzqd',
        options: [{
          label: "循序渐进（每周调整1项）",
          key: '1'
        }, {
          label: "中度改变",
          key: '2'
        }, {
          label: "全面调整",
          key: '3'
        }]
      }],
      formData: {
      }
    }
  },
  created() {

  },
  mounted() {
    this.formData = {...this.initData}
  },
  methods: {
    onSubmit(data) {
      console.log('onSubmit', data);
      this.$emit('next-step',{type:'dietaryImprovement',data})
    },
    onClickPrev() {
      
      this.$emit('prev-step')
    }
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.bodyinfo-page {
  width: 100%;
  height: 100vh;
  padding: 2rem;
  background-color: #fff;
}

.bodyinfo-page .title {
  height: 2.33rem;
  font-weight: 500;
  font-size: 1.67rem;
  color: #333333;
  line-height: 2.33rem;
  margin-bottom: 2rem;
}

.form-wrapper {
  padding-bottom: 5rem;
}

.form-wrapper .form-item {
  margin-bottom: 2rem;
}

.form-wrapper .form-item .form-item-label {
  font-weight: 500;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  text-align: left;
  margin-bottom: 1rem;
}

.form-wrapper .form-item .form-item-input {
  /* width: 100%;
  height: 3.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  background: #F8F9FA; */
}

.icon-mark {
  width: 100px;
  font-size: 1.17rem;
}

.form-wrapper .form-item .form-item-input .van-cell {
  /* background: #F8F9FA; */
  padding-left: 0;
  border-bottom: 1px solid #e8e9ec;
}

.next-btn-wrapper {
  width: 100%;
  height: 6.9rem;
  display: flex;
  gap: 1.42rem;
  background-color: #fff;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  padding: 0.33rem 2rem;
  box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}

.form-wrapper .form-item .van-radio__label,
.bodyinfo-page .van-radio__label {
  font-size: 1.33rem;
  margin-bottom: 1rem;
}
</style>
